import { defineComponent as k, useSlots as S, computed as i, openBlock as t, createBlock as b, resolveDynamicComponent as C, normalizeClass as q, withCtx as I, createElementBlock as r, renderSlot as s, createTextVNode as l, createCommentVNode as a, createElementVNode as n, toDisplayString as d, createVNode as m, unref as T } from "vue";
import p from "./novoui-vuejs10.js";
import "./novoui-vuejs71.js";
import "./novoui-vuejs72.js";
import "./novoui-vuejs3.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import "./novoui-vuejs41.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs19.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import $ from "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs28.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
import { ECardSize as c, ECardElevation as u } from "./novoui-vuejs56.js";
const z = {
  key: 0,
  class: "card-header"
}, H = {
  key: 1,
  class: "card-header"
}, B = ["src"], E = {
  key: 0,
  class: "card-header-title"
}, N = {
  key: 1,
  class: "card-header-subtitle"
}, w = {
  key: 1,
  class: "card-header-icon"
}, V = {
  key: 2,
  class: "card-media"
}, x = {
  key: 3,
  class: "card-media"
}, D = ["src"], F = {
  key: 4,
  class: "card-body"
}, M = {
  key: 5,
  class: "card-body"
}, R = { key: 0 }, j = { key: 1 }, A = {
  key: 6,
  class: "card-footer"
}, G = {
  key: 7,
  class: "card-footer"
}, J = { class: "card-footer-icon" }, ze = /* @__PURE__ */ k({
  __name: "NCard",
  props: {
    /**
     * The size of the button allows only some values
     */
    size: {
      type: String,
      required: !1,
      default: c.medium
    },
    /**
     * The elevation of the card
     */
    elevation: {
      type: String,
      required: !1,
      default: u.elevated
    },
    /**
     * Indicates if the card is disabled
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * The source of the avatar image, displayed in the header section.
     * If header slot is used, this will be ignored
     */
    avatarImage: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The headline of the card, displayed in the header section.
     * If header slot is used, this will be ignored
     */
    headline: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The subheader of the card, displayed in the header section.
     * If header slot is used, this will be ignored
     */
    subheader: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The header icon, displayed in the header section.
     * If header slot is used, this will be ignored
     */
    headerIcon: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The image of the card, displayed in the media section.
     * If media slot is used, this will be ignored
     */
    mediaImage: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The tag label displayed on the image.
     * If media slot is used, this will be ignored
     */
    mediaImageTag: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The headline of the card, displayed in the body section.
     * If default slot is used, this will be ignored
     */
    bodyHeadline: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The main text of the card, displayed in the body section.
     * If default slot is used, this will be ignored
     */
    bodyText: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * The footer text of the card, displayed in the footer section.
     * If footer slot is used, this will be ignored
     */
    footerText: {
      type: String,
      required: !1,
      default: ""
    },
    /**
     * Supplying a method here changes the card into an html button and processes the supplied method when the card is clicked. Overwrites the effect of the Link prop.
     */
    onClick: {
      type: Function,
      required: !1,
      default: null
    },
    /**
     * Supplying a link here changes the card into an html anchor and redirects to the supplied link when the card is clicked.
     */
    link: {
      type: String,
      required: !1,
      default: ""
    }
  },
  setup(f) {
    const e = f;
    S();
    const h = i(() => e.link ? "a" : e.onClick ? "button" : "div"), y = i(() => {
      switch (e.elevation) {
        case u.elevated:
          return "card-elevated";
        case u.outline:
          return "card-outline";
        case u.fill:
          return;
      }
    }), _ = i(() => {
      switch (e.size) {
        case c.small:
          return "card-sm";
        case c.medium:
          return "card-md";
        case c.large:
          return "card-lg";
      }
    }), g = i(() => e.avatarImage || e.headline || e.subheader || e.headerIcon), v = i(() => e.bodyHeadline || e.bodyText);
    return (o, K) => (t(), b(C(h.value), {
      href: e.link ? e.link : null,
      onClick: e.onClick,
      class: q([
        "card",
        y.value,
        _.value,
        {
          "card-disabled": e.disabled,
          "card-clickable": e.link || e.onClick
        }
      ])
    }, {
      default: I(() => [
        o.$slots.headerSlot ? (t(), r("div", z, [
          s(o.$slots, "headerSlot", {}, () => [
            l("HeaderSlot")
          ])
        ])) : g.value ? (t(), r("div", H, [
          e.avatarImage ? (t(), r("img", {
            key: 0,
            class: "card-header-avatar",
            src: e.avatarImage
          }, null, 8, B)) : a("", !0),
          n("div", null, [
            e.headline ? (t(), r("p", E, d(e.headline), 1)) : a("", !0),
            e.subheader ? (t(), r("p", N, d(e.subheader), 1)) : a("", !0)
          ]),
          e.headerIcon ? (t(), r("div", w, [
            m(p, {
              icon: e.headerIcon,
              size: 24
            }, null, 8, ["icon"])
          ])) : a("", !0)
        ])) : a("", !0),
        o.$slots.mediaSlot ? (t(), r("div", V, [
          s(o.$slots, "mediaSlot", {}, () => [
            l("MediaSlot")
          ])
        ])) : e.mediaImage ? (t(), r("div", x, [
          n("img", {
            src: e.mediaImage
          }, null, 8, D),
          m(T($), {
            class: "card-media-status-tag",
            state: "none",
            label: e.mediaImageTag
          }, null, 8, ["label"])
        ])) : a("", !0),
        o.$slots.default ? (t(), r("div", F, [
          s(o.$slots, "default", {}, () => [
            l("DefaultSlot")
          ])
        ])) : v.value ? (t(), r("div", M, [
          e.bodyHeadline ? (t(), r("h5", R, d(e.bodyHeadline), 1)) : a("", !0),
          e.bodyText ? (t(), r("p", j, d(e.bodyText), 1)) : a("", !0)
        ])) : a("", !0),
        o.$slots.footerSlot ? (t(), r("div", A, [
          s(o.$slots, "footerSlot", {}, () => [
            l("FooterSlot")
          ])
        ])) : e.footerText ? (t(), r("div", G, [
          n("p", null, d(e.footerText), 1),
          n("div", J, [
            m(p, {
              icon: "arrowRight",
              size: 24
            })
          ])
        ])) : a("", !0)
      ]),
      _: 3
    }, 8, ["href", "onClick", "class"]));
  }
});
export {
  ze as default
};
